import React from 'react';
import AboutBanner from './../../../Assets/aboutus.svg';
import './About.css';

const About = props => {
    return (
        <div id="about" className="adg-container">
            <div className="adg-header">
                About our Company
            </div>
            <div className="adg-container-data">
                <div className="adg-data">
                    <p>
                        Audigo is growing Consulting Company with vast experience in Global Business Services Company.
                    </p>
                    <p>
                        We help Entrepreneur’s master their financial lives by providing a range of services and solutions in strategy, consulting, and operations management in an increasingly interconnected world, the importance of working with experienced, local professionals cannot be overstated.
                    </p>
                    <p>
                        Audigo Aims to act as a market leader in helping both local and foreign companies to successfully expand their business globally, by providing a full suite of multi-lingual commercial representation and back-office services.
                    </p>
                    <p>
                        Our clients include some of the best-known global brands as well as startups. We help them work smarter and achieve accelerated growth through process transformation, digital technology enablement, and creation and management of value-generating business services.
                    </p>
                </div>
                <div className="adg-container-banner">
                    <img src={AboutBanner} alt="about-img" />
                </div>
            </div>
        </div>
    );
}

export default About;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/About/About.js